import { ListGroup, ListGroupItem } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import Query from "../common/Query";
import { FormContainerConfig, FormSubmission } from "../form/types";
import { formatDate } from "../utils";
import FORMDETAILS_QUERY from "./queries/FORMDETAILS_QUERY";

const FormDetailsView = () => {
  const { formId }: { formId?: string } = useParams();
  return (
    <Query
      loadingLabel="Loading Your Form"
      variables={{ formId }}
      query={FORMDETAILS_QUERY}
    >
      {({ data: { form } }: { data: { form: FormContainerConfig } }) => {
        return (
          <>
            <h1>
              {form.title}
            </h1>
            <ListGroup>
              {form?.submissions?.map((s: FormSubmission) => {
                const createdAt = formatDate(s.createdAt);
                return (
                  <ListGroupItem>
                    {createdAt} - {s.payload?.user?.email}
                    <Link to={`/forms/submission/${s.id}`} className="float-end">Review</Link>
                  </ListGroupItem>
                );
              })}
            </ListGroup>
          </>
        );
      }}
    </Query>
  );
};

export default FormDetailsView;
